import { createFileRoute } from '@tanstack/react-router';
import { OverviewTab } from '../../pages/dashboard/overview/OverviewTab';

/** `?gift=<usd>` is how the welcome flow tells the overview that a reader has
 *  just finished it with welcome bonuses settled. It is a confirmation of
 *  something that already happened, so a hand-typed or stale value costs
 *  nothing beyond one dismissible block. */
export interface OverviewSearch {
  gift?: number;
}

export const Route = createFileRoute('/dashboard/')({
  validateSearch: (search: Record<string, unknown>): OverviewSearch => {
    const gift = Number(search.gift);
    return Number.isFinite(gift) && gift > 0 ? { gift } : {};
  },
  component: OverviewRoute,
});

function OverviewRoute() {
  const { gift } = Route.useSearch();
  return <OverviewTab welcome={gift !== undefined ? { giftUsd: gift } : undefined} />;
}
